import { defineMessages } from 'react-intl'

export const contactsSidePanelMessages = defineMessages({
  subtitle: {
    defaultMessage: 'Contacts',
    description: 'Subtitle for the contacts side-panel section',
  },
  collapsedTitle: {
    defaultMessage: '{name} (caregiver)',
    description: 'Collapsed/expanded title showing the caregiver name for the contacts side-panel section',
  },
  phone: {
    defaultMessage: 'Phone',
    description: "Label for guardian's phone number",
  },
  email: {
    defaultMessage: 'Email',
    description: "Label for guardian's email",
  },
  voicemailConsent: {
    defaultMessage: '{clientFirstName} provided voicemail consent',
    description: 'Tooltip message indicating that the guardian has provided voicemail consent',
  },
})
